import request from './request'

/**
 * 支付宝预下单-月卡
 * @returns {Promise}
 */
export function alipayPrecreateMonthly() {
  return request({
    url: '/api/pay/alipay/precreate/monthly',
    method: 'post'
  })
}

/**
 * 支付宝预下单-季卡
 * @returns {Promise}
 */
export function alipayPrecreateQuarterly() {
  return request({
    url: '/api/pay/alipay/precreate/quarterly',
    method: 'post'
  })
}

/**
 * 查询订单详情
 * @param {String|Number} orderId - 订单ID
 * @returns {Promise}
 */
export function getOrderDetail(orderId) {
  return request({
    url: '/api/pay/order/detail',
    method: 'get',
    params: {
      orderNo: orderId
    }
  })
}

